"use client"

import clsx from "clsx"
import { FormattedMessage } from "react-intl"

import {
  Box,
  H2,
  IconButton,
  makeMessengerUri,
  useBreakpoint,
  useUser,
} from "@bullseye/components"
import { useRouter } from "@bullseye/navigation"
import { MessageChannel } from "@bullseye/types"

import { MessengerModal, useMessengerModalContext } from "../../"
import { MessageChannelTitle } from "../ChannelTitle"

export function MessageChannelHeader({
  messageChannel,
}: {
  messageChannel?: MessageChannel
}) {
  const { openModal } = useMessengerModalContext()
  const isSm = useBreakpoint("md", "down")
  const { user: selectedUser } = useUser(
    !messageChannel?.experience_id ? messageChannel?.dm_user?.id : undefined,
  )
  const router = useRouter()

  return (
    <Box className="flex w-full flex-row border-solid border-gray-100 bg-white md:border-t">
      <Box className="flex w-full flex-row items-center justify-between border-r border-solid border-gray-100 p-3 px-4 pb-2 md:w-[30%]">
        <H2
          className={clsx({
            hidden: isSm && !!messageChannel,
          })}
        >
          <FormattedMessage id="messenger.title" />
        </H2>
        <Box
          className={clsx(
            "flex max-w-[80%] flex-row items-center g-2 md:hidden",
            {
              hidden: !messageChannel,
            },
          )}
        >
          <IconButton
            iconType="arrow-left"
            variant="filled"
            name="Go back"
            handlePress={() => {
              if (router.canGoBack?.()) {
                return router.back()
              }
              return router.replace(makeMessengerUri())
            }}
          />
          <Box className="flex-1 overflow-x-hidden">
            <MessageChannelTitle messageChannel={messageChannel} />
          </Box>
        </Box>
        <IconButton
          iconType="edit"
          variant="filled"
          size="lg"
          name="New message"
          handlePress={() => openModal(MessengerModal.NewMessage)}
          className={clsx({
            hidden: isSm && !!messageChannel,
          })}
        />
        <IconButton
          variant="filled"
          iconType="info-circle"
          name="Channel info"
          handlePress={() => {
            openModal(MessengerModal.ChannelOptions, {
              user: selectedUser,
              streamChannelId: messageChannel?.id,
              messageChannelId: messageChannel?.id,
            })
          }}
          className={clsx("md:hidden", {
            hidden: isSm && !messageChannel,
          })}
        />
      </Box>
      <Box
        className={clsx(
          "hidden flex-row items-center justify-between border-b border-solid border-gray-100 p-4 md:flex md:w-[70%]",
          {
            "md:hidden": !messageChannel,
          },
        )}
      >
        <MessageChannelTitle messageChannel={messageChannel} />
        <IconButton
          variant="filled"
          iconType="info-circle"
          name="Channel info"
          handlePress={() => {
            openModal(MessengerModal.ChannelOptions, {
              user: selectedUser,
              streamChannelId: messageChannel?.id,
              messageChannelId: messageChannel?.id,
            })
          }}
        />
      </Box>
    </Box>
  )
}
